import {ClaimService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced:true,
    state:{
        definitions:[],
    },
    mutations:{
        saveClaimDefinitions(current, definitions){
            current.definitions.splice(0);
            current.definitions = [...definitions];
        }
    },
    actions:{
        async getClaimDefinitionsAction({commit}){
            await bindLoading(commit, async () => commit('saveClaimDefinitions'
                , await ClaimService.getClaimDefinitions()), 'claim');
        },

        async deleteClaimDefinitionAction({ commit, state}, id) {
            return await bindLoading(commit, async () => {
                const result = await ClaimService.deleteClaimDefinition(id);
                if (result.success) {
                    const newClaims = state.definitions.filter(n => n.id!==id);
                    commit('saveClaimDefinitions', newClaims);
                }
                return result;
            }, 'claim');

        },

        async updateClaimDefinitionAction({ commit, state}, claim) {
            return await bindLoading(commit, async () => {
                const result = await ClaimService.updateClaimDefinition(claim);
                if (result.success) {
                    const updateIdx = state.definitions.findIndex(f => f.id === claim.id);
                    const newClaims = [...state.definitions];
                    newClaims[updateIdx] = claim;
                    commit('saveClaimDefinitions', newClaims);
                }
                return result;
            }, 'claim');

        },

        async insertClaimDefinitionAction({ commit, state}, claim) {
            return await bindLoading(commit, async () => {
                const {success, instance} = await ClaimService.insertClaimDefinition({...claim});
                if (success) {
                    const newClaims = [...state.definitions, {...claim, id : instance.id}];
                    commit('saveClaimDefinitions', newClaims);
                }
                return {success, instance};
            }, 'claim');

        },
    }
}